export enum SideSelectionType {
    LEFT = 'Left',
    RIGHT = 'Right',
    WHOLE = 'Whole'
}